<footer class="background-dark general-dark2-bg">
  <div class="container">

    <ng-container>

      <div class="row ">

        <div class="col-12 col-lg-9">
          <div class="row">
            <div class="d-none d-sm-block d-lg-none col-sm-4 tablet social-icons">
              <span class="icon" (click)="goto(instagramLink.link)"><i class="fab fa-instagram"></i></span>
              <span class="icon" (click)="goto(facebookLink.link)"><i class="fab fa-facebook"></i></span>
              <span class="icon" (click)="goto(youtubeLink.link)"><i class="fab fa-youtube"></i></span>
              <span class="icon" (click)="goto(tripadvisorLink.link)"><svg class="mb-2" width="30px" height="30px" viewBox="0 -96 512.2 512.2" id="Layer_2" xmlns="http://www.w3.org/2000/svg"><style>.st0{fill:#636d65}</style><path class="st0" d="M128.2 127.9C92.7 127.9 64 156.6 64 192c0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1.1-35.4-28.6-64.1-64-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S174 166.7 174 192s-20.5 45.9-45.8 45.9z"/><circle class="st0" cx="128.4" cy="191.9" r="31.9"/><path class="st0" d="M384.2 127.9c-35.4 0-64.1 28.7-64.1 64.1 0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1 0-35.4-28.7-64.1-64.1-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S430 166.7 430 192s-20.5 45.9-45.8 45.9z"/><circle class="st0" cx="384.4" cy="191.9" r="31.9"/><path class="st0" d="M474.4 101.2l37.7-37.4h-76.4C392.9 29 321.8 0 255.9 0c-66 0-136.5 29-179.3 63.8H0l37.7 37.4C14.4 124.4 0 156.5 0 192c0 70.8 57.4 128.2 128.2 128.2 32.5 0 62.2-12.1 84.8-32.1l43.4 31.9 42.9-31.2-.5-1.2c22.7 20.2 52.5 32.5 85.3 32.5 70.8 0 128.2-57.4 128.2-128.2-.1-35.4-14.6-67.5-37.9-90.7zM368 64.8c-60.7 7.6-108.3 57.6-111.9 119.5-3.7-62-51.4-112.1-112.3-119.5 30.6-22 69.6-32.8 112.1-32.8S337.4 42.8 368 64.8zM128.2 288.2C75 288.2 32 245.1 32 192s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2zm256 0c-53.1 0-96.2-43.1-96.2-96.2s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2z"/></svg></span>
            </div>
            <div class="col-xs-12 col-sm-8">
              <div class="row m-0 w-100">
                <div class="input-group email-signup pl-0 col-xs-12 col-md-8 col-lg-9">
                  <form name="newsletter-signup-desktop" id="newsletterFormDesktop" #newsletterForm="ngForm"
                        class="form-grow" (ngSubmit)="onSubmit($event)" ngNativeValidate>
                    <input type="email" name="email1" id="email" class="d-none d-md-block form-control"
                           aria-label="Enter your email address to sign up for our newsletter..." data-netlify="true"
                           placeholder="Enter your email address to sign up for our newsletter..." required>
                  </form>
                  <form name="newsletter-signup-mobile" id="newsletterFormMobile" #newsletterForm="ngForm"
                        class="form-grow" (ngSubmit)="onSubmit($event)">
                    <input type="email" name="email2" id="email2" class="d-block d-md-none form-control"
                           aria-label="Enter your email address" data-netlify="true"
                           placeholder="Enter your email address" required>
                  </form>
                </div>

                <div class="col-xs-12 col-md-4 col-lg-3 pl-0">
                  <div class="d-none d-md-block input-group-append">
                    <button class="btn btn-primary1 text-nowrap" id="signUpDesktop" type="submit"
                            form="newsletterFormDesktop" type="submit" [disabled]="!newsletterForm.form.valid">Sign Up
                    </button>
                  </div>
                  <div class="d-block d-md-none">
                    <button class="btn btn-primary1 text-nowrap" style="width: 42vw" id="signUpMobile" type="submit"
                            form="newsletterFormMobile" [disabled]="!newsletterForm.form.valid">Sign Up
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row drawers">

            <div class="col-md-4 col-lg-3 order-md-2 small">
              <div (click)="toggleDrawer('market-drawer', $event)"
                   class="drawer-toggle d-block d-lg-none d-md-none small">
                Market
              </div>
              <div id="market-drawer" class="drawer small">
                <div class="footer-link" routerLink="/merchants/categories/groceries">Grocers</div>
                <div class="footer-link" routerLink="/merchants/categories/specialty-foods">Specialty Foods</div>
                <div class="footer-link" routerLink="/merchants/categories/shops">Shops</div>
                <div class="footer-link" routerLink="/merchants/categories/restaurants">Restaurants</div>
                <div class="footer-link" routerLink="/merchants/categories/services">Services</div>
                <div class="footer-link" routerLink="/visit" fragment="hotels">Area Hotels</div>
                <div class="footer-link" routerLink="/visit" fragment="tours-attractions">Tours</div>
              </div>
            </div>
            <div class="col-md-4 col-lg-3 order-md-3 small">
              <div (click)="toggleDrawer('visit-drawer', $event)"
                   class="drawer-toggle d-block d-lg-none d-md-none small">
                Visit
              </div>
              <div id="visit-drawer" class="drawer">
                <div class="footer-link"
                     (click)="goto('https://www.google.com/maps/place/6333+W+3rd+St,+Los+Angeles,+CA+90036')">Driving
                  Directions
                </div>
                <div class="footer-link" routerLink="/visit" fragment="parking">Public Transportation</div>
                <div class="footer-link" routerLink="/visit" fragment="parking">Parking</div>
                <div class="footer-link" routerLink="/events">Events</div>
                <div class="footer-link" routerLink="/faq">FAQ</div>
                <div class="footer-link" routerLink="/history">History</div>
                <div class="footer-link" routerLink="/market-office">Market Office</div>
              </div>
            </div>
            <div class="col-md-4 col-lg-3 order-md-4 small">
              <div (click)="toggleDrawer('contact-drawer', $event)"
                   class="drawer-toggle d-block d-lg-none d-md-none small">
                Contact
              </div>
              <div id="contact-drawer" class="drawer">
                <div class="footer-link" routerLink="/market-office">Contact</div>
                <div class="footer-link" routerLink="/market-office" fragment="community">Community Room</div>
                <div class="footer-link" routerLink="/market-office" fragment="contact">Leasing Information</div>
                <div class="footer-link" routerLink="/market-office" fragment="jobs">Job Opportunities</div>
                <div class="footer-link" routerLink="/market-office" fragment="media">Media Inquiries</div>
                <div class="footer-link" routerLink="/privacy-policy">Privacy Policy</div>
                <div class="footer-link" routerLink="/accessibility">Accessibility Statement</div>
              </div>
            </div>

            <div class="col-12 col-lg-3 text-nowrap address-hours-contact pt-4">
              <div class="row address">
                <div class="col-12 col-sm-4 col-lg-12 small">
                  <div class="footer-link-header">Address</div>
                  <div>6333 W. 3rd St.</div>
                  <div>Los Angeles, CA 90036</div>
                </div>
                <!-- not ideal, tablet layout -->
                <div class="d-none d-sm-block col-sm-4 d-lg-none small">
                  <div class="footer-link-header small">Hours</div>
                  <div class="row" *ngIf="!!visitorMapAndHoursData">
                    <div class="col-5">
                      <div *ngIf="!!visitorMapAndHoursData.weekdayHours" [innerHTML]="visitorMapAndHoursData.weekdayHoursText"></div>
                      <div *ngIf="!!visitorMapAndHoursData.weekendHours" [innerHTML]="visitorMapAndHoursData.weekendHoursText"></div>
                    </div>
                    <div class="col-6">
                      <div *ngIf="visitorMapAndHoursData.weekdayHours" [innerHTML]="visitorMapAndHoursData.weekdayHours"></div>
                      <div *ngIf="!!visitorMapAndHoursData.weekendHours" [innerHTML]="visitorMapAndHoursData.weekendHours"></div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-sm-block col-sm-4 d-lg-none small">
                  <div class="footer-link-header small">Contact</div>
                  <div class="row">
                    <div class="col-5">
                      <div>Phone</div>
                      <div>Toll Free</div>
                    </div>
                    <div class="col-6">
                      <div><a href="tel:+13239339211">323-933-9211</a></div>
                      <div><a href="tel:+18669939211">866-993-9211</a></div>
                    </div>
                  </div>
                </div>
                <!-- end tablet -->

                <div class="col-12 hours d-block d-sm-none d-lg-block">
                  <div class="footer-link-header small">Hours</div>
                  <div class="row" *ngIf="!!visitorMapAndHoursData">
                    <div class="col-6">
                      <div *ngIf="!!visitorMapAndHoursData.weekdayHours" [innerHTML]="visitorMapAndHoursData.weekdayHoursText"></div>
                      <div *ngIf="!!visitorMapAndHoursData.weekendHours" [innerHTML]="visitorMapAndHoursData.weekendHoursText"></div>
                      <br>
                      <div>Phone</div>
                      <div>Toll Free</div>
                    </div>
                    <div class="col-6">
                      <div *ngIf="!!visitorMapAndHoursData.weekdayHours" [innerHTML]="visitorMapAndHoursData.weekdayHours"></div>
                      <div *ngIf="!!visitorMapAndHoursData.weekendHours" [innerHTML]="visitorMapAndHoursData.weekendHours"></div>
                      <br>
                      <div>
                        <a href="tel:+13239339211">323-933-9211</a>
                      </div>
                      <div>
                        <a href="tel:+18669939211">866-993-9211</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="col-12 col-lg-3 order-lg-first footer-logo">

          <!-- tablet/desktop -->
          <div class="d-none d-md-block">
            <img src="/assets/images/fmla-footer.svg" class="logo-img" alt="Farmers Market Logo" aria-label="Farmers Market Logo">

            <div class="logo-width-wrapper d-none d-lg-block">
              <div *ngIf="!!ratings" class="d-none d-lg-block rating d-flex justify-content-center">
                <!--<img src="/assets/images/star-rating.svg" alt="Four and a half stars">-->
                <a
                  href="https://www.tripadvisor.com/Attraction_Review-g32655-d219483-Reviews-The_Original_Farmers_Market-Los_Angeles_California.html">
                  <div class="stars-outer">
                    <div class="stars-inner"></div>
                  </div>
                  ({{ ratings.reviews }})
                </a>
              </div>

              <div class="social-icons d-flex justify-content-center">
                <span class="icon" (click)="goto(instagramLink.link)"><i class="fab fa-instagram"></i></span>
                <span class="icon" (click)="goto(facebookLink.link)"><i class="fab fa-facebook"></i></span>
                <span class="icon" (click)="goto(youtubeLink.link)"><i class="fab fa-youtube"></i></span>
                <span class="icon" (click)="goto(tripadvisorLink.link)">
                  <svg class="mb-2" width="30px" height="30px" viewBox="0 -96 512.2 512.2" id="Layer_2" xmlns="http://www.w3.org/2000/svg">
                    <style>.st1{fill:#ffffff}</style>
                    <path class="st1" d="M128.2 127.9C92.7 127.9 64 156.6 64 192c0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1.1-35.4-28.6-64.1-64-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S174 166.7 174 192s-20.5 45.9-45.8 45.9z"/>
                    <circle class="st1" cx="128.4" cy="191.9" r="31.9"/>
                    <path class="st1" d="M384.2 127.9c-35.4 0-64.1 28.7-64.1 64.1 0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1 0-35.4-28.7-64.1-64.1-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S430 166.7 430 192s-20.5 45.9-45.8 45.9z"/>
                    <circle class="st1" cx="384.4" cy="191.9" r="31.9"/>
                    <path class="st1" d="M474.4 101.2l37.7-37.4h-76.4C392.9 29 321.8 0 255.9 0c-66 0-136.5 29-179.3 63.8H0l37.7 37.4C14.4 124.4 0 156.5 0 192c0 70.8 57.4 128.2 128.2 128.2 32.5 0 62.2-12.1 84.8-32.1l43.4 31.9 42.9-31.2-.5-1.2c22.7 20.2 52.5 32.5 85.3 32.5 70.8 0 128.2-57.4 128.2-128.2-.1-35.4-14.6-67.5-37.9-90.7zM368 64.8c-60.7 7.6-108.3 57.6-111.9 119.5-3.7-62-51.4-112.1-112.3-119.5 30.6-22 69.6-32.8 112.1-32.8S337.4 42.8 368 64.8zM128.2 288.2C75 288.2 32 245.1 32 192s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2zm256 0c-53.1 0-96.2-43.1-96.2-96.2s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2z"/>
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <!-- phone -->
          <div class="d-block d-md-none">
            <div class="social-icons">
              <span class="icon" (click)="goto(instagramLink.link)"><i class="fab fa-instagram"></i></span>
              <span class="icon" (click)="goto(facebookLink.link)"><i class="fab fa-facebook"></i></span>
              <span class="icon" (click)="goto(youtubeLink.link)"><i class="fab fa-youtube"></i></span>
              <span class="icon" (click)="goto(tripadvisorLink.link)">
                <svg class="mb-2" width="30px" height="30px" viewBox="0 -96 512.2 512.2" id="Layer_2" xmlns="http://www.w3.org/2000/svg">
                  <style>.st1{fill:#ffffff}</style>
                  <path class="st1" d="M128.2 127.9C92.7 127.9 64 156.6 64 192c0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1.1-35.4-28.6-64.1-64-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S174 166.7 174 192s-20.5 45.9-45.8 45.9z"/>
                  <circle class="st1" cx="128.4" cy="191.9" r="31.9"/>
                  <path class="st1" d="M384.2 127.9c-35.4 0-64.1 28.7-64.1 64.1 0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1 0-35.4-28.7-64.1-64.1-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S430 166.7 430 192s-20.5 45.9-45.8 45.9z"/>
                  <circle class="st1" cx="384.4" cy="191.9" r="31.9"/>
                  <path class="st1" d="M474.4 101.2l37.7-37.4h-76.4C392.9 29 321.8 0 255.9 0c-66 0-136.5 29-179.3 63.8H0l37.7 37.4C14.4 124.4 0 156.5 0 192c0 70.8 57.4 128.2 128.2 128.2 32.5 0 62.2-12.1 84.8-32.1l43.4 31.9 42.9-31.2-.5-1.2c22.7 20.2 52.5 32.5 85.3 32.5 70.8 0 128.2-57.4 128.2-128.2-.1-35.4-14.6-67.5-37.9-90.7zM368 64.8c-60.7 7.6-108.3 57.6-111.9 119.5-3.7-62-51.4-112.1-112.3-119.5 30.6-22 69.6-32.8 112.1-32.8S337.4 42.8 368 64.8zM128.2 288.2C75 288.2 32 245.1 32 192s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2zm256 0c-53.1 0-96.2-43.1-96.2-96.2s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2z"/>
                </svg>
              </span>
            </div>
            <div class="row d-flex align-items-center">
              <div class="col-4 offset-1">
                <img class="mobile-footer-logo" src="/assets/images/footer-logo.svg" alt="Farmers Market Logo" aria-label="Farmers Market Logo">
              </div>
              <div class="col-6 copyright d-flex justify-content-end">
                <div>
                  © 2025 AF Gilmore, Co.<br> All Rights Reserved.<br>
                  <!-- <span class="footer-link small">Terms</span> | --> <span class="footer-link small"
                                                                                routerLink="/privacy-policy">Privacy</span>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <div class="row d-none d-md-block">
        <div class="col-12 copyright text-center">
          <div class="pb-4">We use cookies to enhance your browsing experience, serve personalized  content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies. You can change your preferences in <span class="footer-link small cursor-pointer" data-cc="show-preferencesModal">Cookie Preferences</span></div>
          <div class="pb-4 footer-link small"><a href="/market-office?type=privacy">Do Not Sell or Share My  Personal Information & Limit the Use of My Sensitive Personal Information</a></div>
          <div>© 2025 AF Gilmore, Co. All Rights Reserved. <!--<span class="footer-link small">Terms</span> |--> <span class="footer-link small" routerLink="/privacy-policy">Privacy</span></div>
        </div>
      </div>
    </ng-container>
  </div>
</footer>
